// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__f99zU","modal-header":"Modal_modal-header__d8P6O","modal-content":"Modal_modal-content__0Z+4+"};